import { render, staticRenderFns } from "./ReleMonitor.vue?vue&type=template&id=0d69c55a&"
import script from "./ReleMonitor.vue?vue&type=script&lang=js&"
export * from "./ReleMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports